import { request } from "./http";

export interface Deposit {
  id: string;
  user_id: string | null;
  amount: string;
  currency: string;
  processor: string;
  processor_ref: string | null;
  status: string;
  trading_account_id: string | null;
  failure_reason: string | null;
  created_at: string | null;
  settled_at: string | null;
}

export const deposits = {
  listMine: () => request<Deposit[]>("/api/v1/deposits"),
  adminAll: (status?: string) =>
    request<Deposit[]>(`/api/v1/deposits/admin${status ? `?status=${encodeURIComponent(status)}` : ""}`),
  confirm: (id: string) => request<{ status: string }>(`/api/v1/deposits/${id}/confirm`, { body: {} }),
  fail: (id: string, failure_reason?: string) =>
    request<{ status: string }>(`/api/v1/deposits/${id}/fail`, { body: { failure_reason } }),
};
